import { useHttpClient } from "@/common/api/httpClient";
import type { LogSorterResponse } from "./common/logSorterResponse";
import { useLanguageStore } from "shared/translations/stores/languageStore";
import { storeToRefs } from "pinia";

export interface QueryLogSorterRequest {
  binId?: string;
}

export interface QueryLogSorterSuccessResponse {
  ok: true;
  logSorter: LogSorterResponse;
}

export function useQueryLogSorter() {
  const httpClient = useHttpClient();
  const languageStore = useLanguageStore();
  const { translations } = storeToRefs(languageStore);

  return {
    execute
  };

  async function execute(action: QueryLogSorterRequest) {

    const headers = httpClient.defaultHeaders();
    const request = new Request(httpClient.siteUrl(`logsorter/query`), {
      headers,
      method: 'post',
      body: JSON.stringify(action)
    });

    const text = translations.value.logSorter.actions.query;

    const response = await httpClient.action<QueryLogSorterSuccessResponse>(request, {
      title: text.title,
      errorTitle: text.error,
      async processOk(response) {
        const json = await response.json() as LogSorterResponse;

        return {
          ok: true,
          logSorter: json
        };
      },
    });

    return response;
  }
}
